import React from 'react';
import {
  Box,
  Controller,
  ControllerWrapper,
  FieldWrapper,
  FormFieldsContainer,
  Label,
  RegularField,
  useFormContext,
  useResponsive,
} from '@common-fe/common-fe';

import { AppProviderField, AppProviderForm } from './useAddProviderForm';

const AddProviderForm = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<AppProviderForm>();
  const { isMobile } = useResponsive();
  return (
    <Box
      pad={
        isMobile
          ? { vertical: 'spacing16', horizontal: 'spacing16' }
          : { vertical: 'spacing24', horizontal: 'spacing32' }
      }
      background="canvas"
      round="container1Round"
    >
      <FormFieldsContainer>
        <FieldWrapper>
          <Label name={AppProviderField.provideName} showRequireIcon isNarrow>
            Provider/Merchant name
          </Label>

          <ControllerWrapper errorText={errors?.[AppProviderField.provideName]?.message}>
            <Controller
              name={AppProviderField.provideName}
              control={control}
              render={({ field }) => (
                <RegularField
                  name={AppProviderField.provideName}
                  value={field.value}
                  onChange={field.onChange}
                  placeholder="Enter name"
                  isError={!!errors?.[AppProviderField.provideName]?.message}
                  style={{ width: isMobile ? 'auto' : '320px' }}
                  editMode
                />
              )}
            />
          </ControllerWrapper>
        </FieldWrapper>
      </FormFieldsContainer>
    </Box>
  );
};

export default AddProviderForm;
